interface iContent {
  file_name: string;
  presigned_url: string;
  post_type?: string;
}

type SearchResultItem = string | { presigned_url: string; post_type?: string };

function extractPostTypeFromFileName(fileName: string): string {
  const match = fileName.match(/post_type=([^---]+)/);
  return match ? match[1] : "";
}

export const optionsType = [
  "Ato",
  "Avisos",
  "Circular",
  "Concursos",
  "Contrato",
  "Deliberação",
  "Dispensa de Licitação",
  "Edital",
  "Errata de Publicação",
  "Extrato",
  "Inexigibilidade de Licitação",
  "Licitação",
  "Manifestação",
  "Portaria",
  "Provimento",
  "Relatório",
  "Resolução",
  "Resultados",
  "Súmulas",
];

export const regulationTitle = "O que é o diário oficial?";

export const regulationLearnMoreUrl =
  "https://atos.defensoria.sc.def.br/api/render-html/?file_key=origin=Defensor%20P%C3%BAblico-Geral---date=06-10-2022---file=Ato_n%C2%BA59.html";

export const regulation =
    "O Diário Oficial Eletrônico da Defensoria Pública do Estado de Santa Catarina é o instrumento oficial de publicação, divulgação e comunicação dos seus atos processuais e administrativos. Foi instituído pela Lei Complementar nº 805/202 de 1º de julho de 2022, e regulamentado pelos Atos DPG nº 059/2022, de 04 de outubro de 2022 e nº 072/2022, de 21 de novembro de 2022.";

export function dateFormat(dateString: string) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
}

export function formatDateFromObject(date: any) {
  const day = date.day < 10 ? `0${date.day}` : date.day;
  const month = date.month < 10 ? `0${date.month}` : date.month;
  return `${day}-${month}-${date.year}`;
}

export function formatUploadDate(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());
  return `${day}-${month}-${year}`;
}

export function getDefaultScheduleDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export function exhibitionDateFormat(dateString: string) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
}

export const formatDate = (date: any) => {
  const year = String(date.year).padStart(2, "0");
  const month = String(date.month).padStart(2, "0");
  const day = String(date.day).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function formatDateFromJsDate(date: Date) {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function hourFormat(hour: string) {}

export function handleKeyPress(
    event: any,
    handleSubmit: any,
    key: string,
    different?: string | string[]
) {
  const differentArray = Array.isArray(different) ? different : [different];

  if (event.key === key && !differentArray.includes(event.target.name)) {
    handleSubmit();
  }
}

export function handleExtract(data: iContent[], setContent: any) {
  data?.forEach((content: iContent) => {
    const split = content?.file_name?.split("---");
    let date, edition, hour;
    if (split.length === 3) {
      date = split[1].split("=")[1].replace(/-/g, "/");
      edition = split[2].split("=")[1].replace(".pdf", "").replace("_", " ");
      hour = split[0].split("=")[1];
    } else if (split.length === 2) {
      date = split[0].split("=")[1].replace(/-/g, "/");
      edition = split[1].split("=")[1].replace(".pdf", "").replace("_", " ");
      hour = "";
    }

    if (date) {
      const extractedHour = new Date(
          `${date.split("/")[1]}/${date.split("/")[0]}/${
              date.split("/")[2]
          } ${hour}`
      );
      if (extractedHour < new Date()) {
        const extractedInfo = {
          date,
          edition,
          hour,
          type:
            content.post_type ||
            extractPostTypeFromFileName(content.file_name) ||
            "",
          presigned_url: content.presigned_url,
          url: content.presigned_url,
          fileKey: content.file_name,
        };

        setContent((prev: any) => [...prev, extractedInfo]);
      }
    }
  });
}

export function handleExtractUrl(
  urls: SearchResultItem[],
  setContent: any,
  filterPostTypes: string[] = []
) {
  const currentTime = new Date();
  const filterTypeFallback =
    filterPostTypes.length === 1 ? filterPostTypes[0] : "";

  urls?.forEach((item) => {
    const presigned_url =
      typeof item === "string" ? item : item.presigned_url;
    const postType =
      (typeof item === "string" ? "" : item.post_type ?? "") ||
      filterTypeFallback;
    const dateRegex = /date%3D([^&]+)/;
    const hourRegex = /hour%3D([^&]+)/;
    const fileNameRegex = /file%3D([^&]+)/;

    const dateMatch = presigned_url.match(dateRegex);
    const hourMatch = presigned_url.match(hourRegex);
    const fileNameMatch = presigned_url.match(fileNameRegex);

    if (dateMatch && fileNameMatch) {
      let date = decodeURIComponent(dateMatch[1]).replace(/-/g, "/");
      let hour = hourMatch ? decodeURIComponent(hourMatch[1]) : "";
      let edition = decodeURIComponent(fileNameMatch[1]);

      const questionMarkIndex = edition.indexOf(".pdf");
      if (questionMarkIndex !== -1) {
        edition = edition.substring(0, questionMarkIndex).replace("_", " ");
      }

      const tripleDashMarkIndex = hour.indexOf("---");
      if (tripleDashMarkIndex !== -1) {
        hour = hour.substring(0, tripleDashMarkIndex);
      }

      const tripleQuestionMarkIndex = date.indexOf("///");
      if (tripleQuestionMarkIndex !== -1) {
        date = date.substring(0, tripleQuestionMarkIndex);
      }

      const extractedInfo = {
        date,
        hour: hour ? hour : "00:00",
        edition,
        type: postType,
        presigned_url,
        url: presigned_url,
      };
      const extractedHour = new Date(
          `${date.split("/")[1]}/${date.split("/")[0]}/${
              date.split("/")[2]
          } ${hour}`
      );
      if (extractedHour < currentTime) {
        setContent((prev: any) => [...prev, extractedInfo]);
      }
    }
  });
}

export function returnHandleExtractUrl(url: any) {
  const dateRegex = /date%3D([^&]+)/;

  const dateMatch = url.match(dateRegex);

  if (dateMatch) {
    let date = decodeURIComponent(dateMatch[1]).replace(/-/g, "/");

    const questionMarkIndex = dateMatch[0].indexOf(".pdf");
    if (questionMarkIndex !== -1) {
      date = dateMatch[0].substring(0, questionMarkIndex + 4);
    }
    return date || "";
  }
}

export function handleResetResponse() {
  setTimeout(() => {
    window.location.reload();
  }, 2 * 1000);
}
